webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  "data-v-8fdb4ca8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  "data-v-44c87288",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  "data-v-cb2fee8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  "data-v-7f1b1bce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_reset_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    StyleEditor: __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default.a,
    ResumeEditor: __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default.a
  },
  data: function data() {
    return {
      interval: 40,
      currentStyle: '',
      enableHtml: false,
      fullStyle: ['/*\n* Inspired by http://strml.net/, sitexa.org/anires/public/\n* \u5927\u5BB6\u597D\uFF0C\u6211\u662F\u660E\u6770\u3002\n* \n* \u6211\u6765\u5199\u4E00\u4EFD\u7B80\u5386\uFF01\n*/\n\n/* \u9996\u5148\u7ED9\u6240\u6709\u5143\u7D20\u52A0\u4E0A\u8FC7\u6E21\u6548\u679C */\n* {\n  transition: all .3s;\n}\n/* \u767D\u8272\u80CC\u666F\u592A\u5355\u8C03\u4E86\uFF0C\u6211\u4EEC\u6765\u70B9\u80CC\u666F */\nhtml {\n  color: rgb(222,222,222); background: rgb(0,43,54);\n}\n/* \u6587\u5B57\u79BB\u8FB9\u6846\u592A\u8FD1\u4E86 */\n.styleEditor {\n  padding: .5em;\n  border: 1px solid;\n  margin: .5em;\n  overflow: auto;\n  width: 45vw; height: 90vh;\n}\n/* \u4EE3\u7801\u9AD8\u4EAE */\n.token.selector{ color: rgb(133,153,0); }\n.token.property{ color: rgb(187,137,0); }\n.token.punctuation{ color: yellow; }\n.token.function{ color: rgb(42,161,152); }\n\n/* \u52A0\u70B9 3D \u6548\u679C\u5457 */\nhtml{\n  perspective: 1000px;\n}\n.styleEditor {\n  position: fixed; left: 0; top: 0;\n  -webkit-transition: none;\n  transition: none;\n  -webkit-transform: rotateY(10deg) translateZ(-100px) ;\n          transform: rotateY(10deg) translateZ(-100px) ;\n}\n\n/* \u63A5\u4E0B\u6765\u6211\u7ED9\u81EA\u5DF1\u51C6\u5907\u4E00\u4E2A\u7F16\u8F91\u5668 */\n.resumeEditor{\n  position: fixed; right: 0; top: 0;\n  padding: .5em;  margin: .5em;\n  width: 48vw; height: 90vh;\n  border: 1px solid;\n  background: white; color: #222;\n  overflow: auto;\n}\n/* \u597D\u4E86\uFF0C\u6211\u5F00\u59CB\u5199\u7B80\u5386\u4E86 */\n\n\n', '\n/* \u8FD9\u4E2A\u7B80\u5386\u597D\u50CF\u5DEE\u70B9\u4EC0\u4E48\n * \u5BF9\u4E86\uFF0C\u8FD9\u662F Markdown \u683C\u5F0F\u7684\uFF0C\u6211\u9700\u8981\u53D8\u6210\u5BF9 HR \u66F4\u53CB\u597D\u7684\u683C\u5F0F\n * \u7B80\u5355\uFF0C\u7528\u5F00\u6E90\u5DE5\u5177\u7FFB\u8BD1\u6210 HTML \u5C31\u884C\u4E86\n */\n', '\n/* \u518D\u5BF9 HTML \u52A0\u70B9\u6837\u5F0F */\n.resumeEditor{\n  padding: 2em;\n}\n.resumeEditor h2,.resumeEditor h3{\n  border-bottom: 1px dashed ;\n  margin: 1em 0 .5em;\n}\n.resumeEditor li {\n  margin: 4px auto auto 18px;\n}\n\n/*\u7ED9\u540D\u5B57\u52A0\u70B9\u8272\u5F69\u5427*/\n.resumeEditor sup {\n  display: inline-block;\n  border-radius: 50%;\n  background: red;\n  color: yellow;\n  width: 14px;\n  height: 14px;\n  text-align: center;\n  line-height: 14px;\n  margin-left: -2px;\n}\n\n/*\u597D\u5566\uFF0C\u5B8C\u6210*/\n\n'],
      currentMarkdown: '',
      fullMarkdown: '\n\n### \u5468\u660E\u6770\t<sup>v</sup>\n\n\u5750\u6807\uFF1A\u4E0A\u6D77\u6D66\u4E1C\u3002\n\n\u5C97\u4F4D: \u524D\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08\u3002\n\n\n## \u6280\u80FD\n\n### \u524D\u7AEF\u5F00\u53D1\n\n  - Web \u7F51\u7AD9\n  - \u54CD\u5E94\u5F0F\u7F51\u7AD9\n  - Web App\n  - \u79FB\u52A8\u7EC8\u7AEF(Native App, Hybrid App)\n  - \u535A\u5BA2\u7CFB\u7EDF\n  - \u516C\u4F17\u53F7\u5F00\u53D1\n  - \u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u5F00\u53D1\n  - Js \u5C0F\u578B\u6E38\u620F\n\n### \u76F8\u5173\u9879\u76EE\n\n  - VOC\uFF08\u5BA2\u6237\u4E4B\u58F0\u6570\u636E\u5206\u6790\u7CFB\u7EDF\uFF09\n  - \u7535\u529B\u80FD\u6E90\u4E91\u5E73\u53F0\n  - \u7F51\u533B\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\n  - \u6EF4\u6EF4\u62A4\u5DE5\n  - \u5B98\u7F51\u6539\u7248\n  - \u5C71\u4E3D\u5B98\u65B9\u5728\u7EBF\u62BD\u5956\u7CFB\u7EDF\n  - \u5145\u7535\u6869\u5E73\u53F0\u9879\u76EEDemo\n \n\n### \u6280\u672F\u53CA\u8BED\u8A00\n\n  - JavaScript: ES5, ES6, ES7\n  - UI\u53CA\u6846\u67B6: Vue(\u7CFB\u5217),\u5C0F\u7A0B\u5E8F(\u7CFB\u5217),bootstrap, weui, miui, element-ui, echarts, highcharts, hexo, JQuery\n  - Node.js: koa2, pug\n  - DB: MySQL\n  - WebServer: apache, nginx, tomcat\n  - Others: svn, git, Axure, PS, \u84DD\u6E56\n\n### \u5DE5\u4F5C\u7ECF\u5386\n\n - \u4E0A\u6D77\u5B9D\u5C0A\u7535\u5B50\u5546\u52A1\u6709\u9650\u5DE5\u8D44\n - \u4E0A\u6D77\u5C71\u4E3D\u4FE1\u606F\u5B89\u5168\u6709\u9650\u516C\u53F8\n - \u4E0A\u6D77\u8FBE\u95FB\u79D1\u6280\u6709\u9650\u516C\u53F8\n\n### \u6559\u80B2\u7ECF\u5386\n\n - \u6CB3\u5357\u5927\u5B66 \u6C11\u751F\u5B66\u9662\u5B66\u58EB 2011-2015\n\n### \u94FE\u63A5\n\n* [\u4E2A\u4EBA\u7F51\u7AD9](http://www.zhoumingjie.com)\n\n\n### \u8054\u7CFB\u65B9\u5F0F\n\n* \u7535\u8BDD\uFF1A18506835661\n* \u5FAE\u4FE1\uFF1A1032151090\n* \u90AE\u7BB1\uFF1Amingjie.zhou@hotmail.com\n\n### \u79BB\u7EBF\u7B80\u5386\n\n<a href="http://www.zhoumingjie.com/Js-resume/static/resume.pdf" target="_blank">\u4E0B\u8F7D\u79BB\u7EBF\u7B80\u5386</a>\n\n\n'
    };
  },
  created: function created() {
    this.makeResume();
  },


  methods: {
    makeResume: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.progressivelyShowStyle(0);

              case 2:
                _context.next = 4;
                return this.progressivelyShowResume();

              case 4:
                _context.next = 6;
                return this.progressivelyShowStyle(1);

              case 6:
                _context.next = 8;
                return this.showHtml();

              case 8:
                _context.next = 10;
                return this.progressivelyShowStyle(2);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function makeResume() {
        return _ref.apply(this, arguments);
      }

      return makeResume;
    }(),
    showHtml: function showHtml() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.enableHtml = true;
        resolve();
      });
    },
    progressivelyShowStyle: function progressivelyShowStyle(n) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var interval = _this2.interval;
        var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this3 = this;

          var style, length, prefixLength, l, char;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  style = this.fullStyle[n];

                  if (style) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt('return');

                case 3:
                  length = this.fullStyle.filter(function (_, index) {
                    return index <= n;
                  }).map(function (item) {
                    return item.length;
                  }).reduce(function (p, c) {
                    return p + c;
                  }, 0);
                  prefixLength = length - style.length;

                  if (this.currentStyle.length < length) {
                    l = this.currentStyle.length - prefixLength;
                    char = style.substring(l, l + 1) || ' ';

                    this.currentStyle += char;
                    if (style.substring(l - 1, l) === '\n' && this.$refs.styleEditor) {
                      this.$nextTick(function () {
                        _this3.$refs.styleEditor.goBottom();
                      });
                    }
                    setTimeout(showStyle, interval);
                  } else {
                    resolve();
                  }

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })).bind(_this2);
        showStyle();
      });
    },
    progressivelyShowResume: function progressivelyShowResume() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var length = _this4.fullMarkdown.length;
        var interval = _this4.interval;
        var showResume = function showResume() {
          if (_this4.currentMarkdown.length < length) {
            _this4.currentMarkdown = _this4.fullMarkdown.substring(0, _this4.currentMarkdown.length + 1);
            var lastChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 1];
            var prevChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 2];
            if (prevChar === '\n' && _this4.$refs.resumeEditor) {
              _this4.$nextTick(function () {
                return _this4.$refs.resumeEditor.goBottom();
              });
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_reset_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    StyleEditor: __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default.a,
    ResumeEditor: __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default.a
  },
  data: function data() {
    return {
      interval: 40,
      currentStyle: '',
      enableHtml: false,
      fullStyle: ['/*\n* Inspired by http://strml.net/, sitexa.org/anires/public/\n* \u5927\u5BB6\u597D\uFF0C\u6211\u662F\u660E\u6770\u3002\n* \u6211\u6765\u5199\u4E00\u4EFD\u7B80\u5386\uFF01\n*/\n\n/* \u9996\u5148\u7ED9\u6240\u6709\u5143\u7D20\u52A0\u4E0A\u8FC7\u6E21\u6548\u679C */\n* {\n  transition: all .3s;\n}\n/* \u767D\u8272\u80CC\u666F\u592A\u5355\u8C03\u4E86\uFF0C\u6211\u4EEC\u6765\u70B9\u80CC\u666F */\nhtml {\n  color: rgb(222,222,222);\n  background: rgb(0,43,54);\n}\n/* \u6587\u5B57\u79BB\u8FB9\u6846\u592A\u8FD1\u4E86 */\n.styleEditor {\n  padding: .5em;\n  border: 1px solid;\n  overflow: auto;\n  width: 90vw;\n  margin: 2.5vh 5vw;\n  height: 90vh;\n}\n/* \u592A\u9AD8\u4E86 */\n.styleEditor {\n  height: 45vh;\n}\n/* \u4EE3\u7801\u9AD8\u4EAE */\n.token.selector{\n  color: rgb(133,153,0);\n}\n.token.property{\n  color: rgb(187,137,0);\n}\n.token.punctuation{\n  color: yellow;\n}\n.token.function{\n  color: rgb(42,161,152);\n}\n\n/* \u52A0\u70B9 3D \u6548\u679C\u5457 */\nhtml{\n  perspective: 1000px;\n}\n.styleEditor {\n  position: fixed; left: 0; top: 0;\n  transform: rotateX(-10deg) translateZ(-50px) ;\n}\n\n/* \u63A5\u4E0B\u6765\u6211\u7ED9\u81EA\u5DF1\u51C6\u5907\u4E00\u4E2A\u7F16\u8F91\u5668 */\n.resumeEditor{\n  position: fixed;\n  top: 50%; left: 0;\n  padding: .5em;  margin: 2.5vh;\n  width: 95vw; height: 45vh;\n  border: 1px solid;\n  background: #fff; color: #222;\n  overflow: auto;\n}\n/* \u597D\u4E86\uFF0C\u6211\u5F00\u59CB\u5199\u7B80\u5386\u4E86 */\n\n\n', '\n/* \u8FD9\u4E2A\u7B80\u5386\u597D\u50CF\u5DEE\u70B9\u4EC0\u4E48\n * \u5BF9\u4E86\uFF0C\u8FD9\u662F Markdown \u683C\u5F0F\u7684\uFF0C\u6211\u9700\u8981\u53D8\u6210\u5BF9 HR \u66F4\u53CB\u597D\u7684\u683C\u5F0F\n * \u7B80\u5355\uFF0C\u7528\u5F00\u6E90\u5DE5\u5177\u7FFB\u8BD1\u6210 HTML \u5C31\u884C\u4E86\n */\n', '\n/* \u518D\u5BF9 HTML \u52A0\u70B9\u6837\u5F0F */\n.resumeEditor{\n  padding: 2em;\n}\n.resumeEditor h2,.resumeEditor h3{\n\n  border-bottom: 1px dashed ;\n  margin: 1em 0 .5em;\n}\n.resumeEditor ul,.resumeEditor ol{\n  list-style: none;\n}\n.resumeEditor li {\n\tmargin-top: 4px;\n}\n.resumeEditor ul> li::before{\n\n  content: \'\u2022\';\n  margin-right: .5em;\n}\n.resumeEditor ol {\n  counter-reset: section;\n}\n.resumeEditor ol li::before {\n  counter-increment: section;\n  content: counters(section, ".") " ";\n  margin-right: .5em;\n}\n.resumeEditor blockquote {\n  margin: 1em;\n  padding: .5em;\n  background: #ddd;\n}\n\n/*\u7ED9\u540D\u5B57\u52A0\u70B9\u8272\u5F69\u5427*/\n.resumeEditor sup {\n  display: inline-block;\n  border-radius: 50%;\n  background: red;\n  color: yellow;\n  width: 14px;\n  height: 14px;\n  text-align: center;\n  line-height: 14px;\n  margin-left: -2px;\n}\n\n/*\u597D\u5566\uFF0C\u5B8C\u6210*/\n\n'],
      currentMarkdown: '',
      fullMarkdown: '\n\n### \u5468\u660E\u6770\t<sup>v</sup>\n\n\u5750\u6807\uFF1A\u4E0A\u6D77\u6D66\u4E1C\u3002\n\n\u5C97\u4F4D: \u524D\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08\u3002\n\n\n## \u6280\u80FD\n\n### \u524D\u7AEF\u5F00\u53D1\n\n  - Web \u7F51\u7AD9\n  - \u54CD\u5E94\u5F0F\u7F51\u7AD9\n  - Web App\n  - \u79FB\u52A8\u7EC8\u7AEF(Native App, Hybrid App)\n  - \u535A\u5BA2\u7CFB\u7EDF\n  - \u516C\u4F17\u53F7\u5F00\u53D1\n  - \u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u5F00\u53D1\n  - Js \u5C0F\u578B\u6E38\u620F\n\n### \u76F8\u5173\u9879\u76EE\n\n  - VOC\uFF08\u5BA2\u6237\u4E4B\u58F0\u6570\u636E\u5206\u6790\u7CFB\u7EDF\uFF09\n  - \u7535\u529B\u80FD\u6E90\u4E91\u5E73\u53F0\n  - \u7F51\u533B\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\n  - \u6EF4\u6EF4\u62A4\u5DE5\n  - \u5B98\u7F51\u6539\u7248\n  - \u5C71\u4E3D\u5B98\u65B9\u5728\u7EBF\u62BD\u5956\u7CFB\u7EDF\n  - \u5145\u7535\u6869\u5E73\u53F0\u9879\u76EEDemo\n \n\n### \u6280\u672F\u53CA\u8BED\u8A00\n\n  - JavaScript: ES5, ES6, ES7\n  - UI\u53CA\u6846\u67B6: Vue(\u7CFB\u5217),\u5C0F\u7A0B\u5E8F(\u7CFB\u5217),bootstrap, weui, miui, element-ui, echarts, highcharts, hexo, JQuery\n  - Node.js: koa2, pug\n  - DB: MySQL\n  - WebServer: apache, nginx, tomcat\n  - Others: svn, git, Axure, PS, \u84DD\u6E56\n\n### \u5DE5\u4F5C\u7ECF\u5386\n\n1. \u4E0A\u6D77\u5B9D\u5C0A\u7535\u5B50\u5546\u52A1\u6709\u9650\u5DE5\u8D44\n2. \u4E0A\u6D77\u5C71\u4E3D\u4FE1\u606F\u5B89\u5168\u6709\u9650\u516C\u53F8\n3. \u4E0A\u6D77\u8FBE\u95FB\u79D1\u6280\u6709\u9650\u516C\u53F8\n\n### \u6559\u80B2\u7ECF\u5386\n\n1. \u6CB3\u5357\u5927\u5B66 \u6C11\u751F\u5B66\u9662\u5B66\u58EB 2011-2015\n\n### \u94FE\u63A5\n\n* [\u4E2A\u4EBA\u535A\u5BA2](http://www.zhoumingjie.com)\n\n\n### \u8054\u7CFB\u65B9\u5F0F\n\n* \u7535\u8BDD\uFF1A185068356661\n* \u5FAE\u4FE1\uFF1A1032151090\n* \u90AE\u7BB1\uFF1Amingjie.zhou@hotmail.com\n\n### \u79BB\u7EBF\u7B80\u5386\n\n<a href="http://www.zhoumingjie.com/Js-resume/static/resume.pdf" target="_blank">\u4E0B\u8F7D\u79BB\u7EBF\u7B80\u5386</a>\n\n'
    };
  },
  created: function created() {
    this.makeResume();
  },


  methods: {
    makeResume: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.progressivelyShowStyle(0);

              case 2:
                _context.next = 4;
                return this.progressivelyShowResume();

              case 4:
                _context.next = 6;
                return this.progressivelyShowStyle(1);

              case 6:
                _context.next = 8;
                return this.showHtml();

              case 8:
                _context.next = 10;
                return this.progressivelyShowStyle(2);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function makeResume() {
        return _ref.apply(this, arguments);
      }

      return makeResume;
    }(),
    showHtml: function showHtml() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.enableHtml = true;
        _this.$nextTick(function () {
          _this.$refs.resumeEditor.goTop();
        });
        resolve();
      });
    },
    progressivelyShowStyle: function progressivelyShowStyle(n) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var interval = _this2.interval;
        var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this3 = this;

          var style, length, prefixLength, l, char;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  style = this.fullStyle[n];

                  if (style) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt('return');

                case 3:
                  length = this.fullStyle.filter(function (_, index) {
                    return index <= n;
                  }).map(function (item) {
                    return item.length;
                  }).reduce(function (p, c) {
                    return p + c;
                  }, 0);
                  prefixLength = length - style.length;

                  if (this.currentStyle.length < length) {
                    l = this.currentStyle.length - prefixLength;
                    char = style.substring(l, l + 1) || ' ';

                    this.currentStyle += char;
                    if (style.substring(l - 1, l) === '\n' && this.$refs.styleEditor) {
                      this.$nextTick(function () {
                        _this3.$refs.styleEditor.goBottom();
                      });
                    }
                    setTimeout(showStyle, interval);
                  } else {
                    resolve();
                  }

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })).bind(_this2);
        showStyle();
      });
    },
    progressivelyShowResume: function progressivelyShowResume() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var length = _this4.fullMarkdown.length;
        var interval = _this4.interval;
        var showResume = function showResume() {
          if (_this4.currentMarkdown.length < length) {
            _this4.currentMarkdown = _this4.fullMarkdown.substring(0, _this4.currentMarkdown.length + 1);
            var lastChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 1];
            var prevChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 2];
            if (prevChar === '\n' && _this4.$refs.resumeEditor) {
              _this4.$nextTick(function () {
                return _this4.$refs.resumeEditor.goBottom();
              });
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['markdown', 'enableHtml'],
  name: 'ResumeEditor',
  computed: {
    result: function result() {
      return this.enableHtml ? __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.markdown) : this.markdown;
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    },
    goTop: function goTop() {
      this.$refs.container.scrollTop = 0;
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Editor',
  props: ['code'],
  computed: {
    highlightedCode: function highlightedCode() {
      return __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlight(this.code, __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.languages.css);
    },
    codeInStyleTag: function codeInStyleTag() {
      return "<style>" + this.code + "</style>";
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    }
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mobile__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Mobile__);




var width = document.documentElement.clientWidth;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(width > 500 ? __WEBPACK_IMPORTED_MODULE_1__App___default.a : __WEBPACK_IMPORTED_MODULE_2__Mobile___default.a);
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "styleEditor"
  }, [_c('div', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.codeInStyleTag)
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedCode)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "resumeEditor",
    class: {
      htmlMode: _vm.enableHtml
    }
  }, [(_vm.enableHtml) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.result)
    }
  }) : _c('pre', [_vm._v(_vm._s(_vm.result))])])
},staticRenderFns: []}

/***/ })

},[50]);


// WEBPACK FOOTER //
// static/js/app.c80e165ea55171d4a980.js